export default function Loader({ 
  fullPage = false, 
}) {
  return (
    <div className={`${fullPage ? 'vh-100 d-flex' : ''} justify-content-center align-items-center`}>
        <div className="spinner-grow text-light" style={{width:'3rem',height:'3rem'}} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  );
}